import "./_detailMassification.scss";

import cx from "classnames";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";

import {fetchDetailOffre} from "@/api/detailOffre";
import iconBack from "@/assets/massification/iconPrevious.svg";
import logoCofalog from "@/assets/massification/logo-cofalog.png";
import BlocLabel from "@/components/BlocLabel/BlocLabel";
import Button from "@/components/Button/Button";
import CardProduct from "@/components/CardProduct/CardProduct";
import {CardProduct as CardProductInterface} from "@/components/CardProduct/interface";
import Engagement from "@/components/Engagement/Engagement";
import HistoriqueBloc from "@/components/Historique/HistoriqueBloc";
import HistoriqueMassificationContent from "@/components/Historique/HistoriqueMassificationContent";
import LineInfo from "@/components/LineInfo/LineInfo";
import LivraisonInfo from "@/components/LivraisonInfo/LivraisonInfo";
import Loader from "@/components/Loader/loader";
import Palier from "@/components/Palier/Palier";
import Photos from "@/components/Photos/Photos";
import Section from "@/components/Section/Section";
import Title from "@/components/Section/Title";
import Tableau from "@/components/Tableau/Tableau";
import {HookFormContextProvider} from "@/context/HookFormContext";
import {calculePourcentageGain} from "@/function/calculePourcentageGain";
import {dateIsAfterNow} from "@/function/dateFunction";
import {findDataArticle} from "@/function/findDataArticle";
import {formatDate} from "@/function/formatDate";
import {formatPalierPrix, sortPalier} from "@/function/formatPalierPrix";
import {formatTarifFournisseur} from "@/function/formatTarifFournisseur";
import {getPositionCurrentPalier} from "@/function/getCurrentPalier";
import {getBFF} from "@/function/getUrlProdOrPreprod";
import {isPuriel} from "@/function/isPuriel";
import {
  getEngagementValue,
  getResumeEngagement,
  hasPalier,
} from "@/function/massificationTools";
import {
  Article,
  DetailOffre,
  Livraison,
  Palier as PalierInterface,
  PrixQuantitatif,
  TarifFournisseur,
} from "@/ts/interface/detailOffre";

function DetailMassification(): JSX.Element | undefined {
  const navigate = useNavigate();
  const [detailOffre, setDetailOffre] = useState<DetailOffre | null>(null);

  const [searchParams] = useSearchParams();
  const currentArticleId: string | null = searchParams.get("article_id");
  useEffect(() => {
    const getDetailOffre = async (): Promise<void> => {
      const reponse = await fetchDetailOffre(searchParams.get("offre_id"));
      setDetailOffre(reponse || null);
    };
    getDetailOffre();
  }, []);

  if (detailOffre) {
    const {
      nom = "",
      date_fin,
      date_debut,
      articles,
      description = "",
      negociateurs,
      livraisons,
      paliers = [],
      type_palier,
      pricing,
    } = detailOffre || {};

    const offreIsActiveNow = date_debut ? dateIsAfterNow(date_debut) : false;
    const findIndexArticle: number | undefined = articles?.findIndex(
      article => {
        if (currentArticleId) {
          return article.article_id === parseInt(currentArticleId);
        }
        return false;
      },
    );

    const currentArticle: Article | undefined =
      findIndexArticle !== undefined && findIndexArticle >= 0
        ? articles?.[findIndexArticle]
        : undefined;
    if (currentArticle) {
      const {
        article_id,
        nom: produiDesignation,
        gencod,
        code_catalogue,
        description: produiDescription,
        photos,
        prix_vente_constate,
        prix_vente_constate_is_ttc,
        tarif_fournisseur,
        reference,
        fichiers,
        eco_par,
        eco_mob,
        commentaire,
        maximum = 0,
        prix_quantitatif,
      } = currentArticle || {};

      const livraisonFound: Livraison[] | undefined =
        article_id && livraisons
          ? findDataArticle(livraisons, article_id)
          : undefined;
      const palierFound: PalierInterface[] =
        article_id && paliers ? findDataArticle(paliers, article_id) : paliers;
      const offreHasPalier: boolean = hasPalier(
        palierFound?.length,
        palierFound[0]?.nombre,
      );

      const {engagement_value, engagement_article} = getEngagementValue(
        detailOffre,
        currentArticle,
      );

      const isCofalog = (): boolean => {
        let foundCofalog = false;
        if (livraisons) {
          foundCofalog =
            livraisonFound?.some(livraison => {
              const findFournisseur = livraison.fournisseurs.some(
                fournisseur => {
                  //correspond à l'id de cofalog
                  return fournisseur.fournisseur_id === 12380;
                },
              );
              return findFournisseur;
            }) || false;
        }
        return foundCofalog;
      };
      const sortedPalier: PalierInterface[] | undefined =
        palierFound && sortPalier(palierFound);
      const objectifPaliers: number[] | undefined = sortedPalier?.map(
        palier => {
          return palier.nombre;
        },
      );

      const DateFin = (
        date_fin: string | undefined,
      ): JSX.Element | undefined => {
        if (date_fin) {
          return <p>{`Prend fin le ${formatDate(date_fin)}`}</p>;
        }
      };

      // Affiche le nombre d'adhérents et d'unités déjà engagés.
      const NbEngagement = (
        nb_unite: number,
        detailOffre: DetailOffre,
        currentArticle: Article,
      ): JSX.Element | undefined => {
        const maximumQuantite = maximum - nb_unite;

        return (
          <div className="detail-enCour">
            <p className="detail-adherents--engages">
              {getResumeEngagement(detailOffre, currentArticle)}
            </p>

            {maximumQuantite > 0 ? (
              <p className="detail-adherents--engages">{`${maximumQuantite} Encore${isPuriel(maximumQuantite)} disponible${isPuriel(maximumQuantite)}`}</p>
            ) : null}
          </div>
        );
      };

      // Format la donnée pour être compatible avec le format du composant Tableau
      const formatedDataPalierPrix =
        palierFound && prix_quantitatif
          ? formatPalierPrix(prix_quantitatif, palierFound)
          : undefined;

      const formatedTarifs = tarif_fournisseur
        ? formatTarifFournisseur(tarif_fournisseur)
        : undefined;

      const hasTarif =
        formatedTarifs?.findIndex(tarif => {
          return parseFloat(tarif?.celules[0]) > 0;
        }) != -1;
      // Donne le haut tableau à mettre dans le composant.
      const FormatHeadTableau = (
        prixQuantitatif?: PrixQuantitatif[],
      ): JSX.Element | undefined => {
        let quantitatifHead: JSX.Element | null = null;
        let quantitatifValue: JSX.Element[] | null = null;

        if (prixQuantitatif && prixQuantitatif?.length > 0) {
          quantitatifHead = (
            <tr>
              {offreHasPalier ? <th className={cx("hide")}></th> : null}
              <th
                colSpan={prixQuantitatif.length}
                className="tableau-prix-title">
                Prix Quantitatif
              </th>
            </tr>
          );
          quantitatifValue = prixQuantitatif.map((prix, index) => {
            return <th key={prix.prix[0].position + index}>{prix.quantite}</th>;
          });
        }
        return (
          <thead>
            {quantitatifHead}
            <tr>
              {offreHasPalier ? (
                <th>{type_palier === "prix" ? "Montant" : "Unité"}</th>
              ) : null}
              {quantitatifValue}
            </tr>
          </thead>
        );
      };

      // Affiche le pourcentage de gain,
      // Entre le prix palier en cours,
      // Et le prix permanant le plus chère.
      const GainSurPalier = (
        paliers?: PalierInterface[],
        prix_quantitatif?: PrixQuantitatif[],
        prix_vente?: number,
        tarif_fournisseur?: TarifFournisseur[],
        NbEngagement?: number,
        is_TTC?: boolean,
        eco_mob?: number,
        eco_par?: number,
      ): JSX.Element => {
        let Gain: JSX.Element | null = null;
        let PrixVenteConseille: JSX.Element | null = null;
        const EcoTax: JSX.Element | null =
          eco_par || eco_mob ? (
            <>
              <p
                id="ecoTax"
                className={
                  eco_par ? "" : "hidden"
                }>{`Eco-Participation : ${eco_par} €`}</p>
              <p
                id="ecoTax"
                className={
                  eco_mob ? "" : "hidden"
                }>{`Eco-Mobilier : ${eco_mob} €`}</p>
            </>
          ) : null;

        if (prix_vente) {
          PrixVenteConseille = (
            <p>
              Prix de vente conseillé :{" "}
              <span>{`${prix_vente} € ${is_TTC ? "TTC" : "HT"}`}</span>
            </p>
          );
        }
        if (
          paliers &&
          NbEngagement !== undefined &&
          tarif_fournisseur &&
          prix_quantitatif
        ) {
          const positionCurrentPalier: number = getPositionCurrentPalier(
            paliers,
            NbEngagement,
          );
          const currentPrix: {position: number; valeur: string} | undefined =
            prix_quantitatif[0].prix.find(
              prix => prix.position === positionCurrentPalier,
            );
          const tarifFournisseur: string = tarif_fournisseur[0].valeur;
          const pourcentageGain = currentPrix
            ? calculePourcentageGain(
                parseFloat(tarifFournisseur),
                parseFloat(currentPrix?.valeur),
              )
            : "0";
          Gain =
            parseFloat(pourcentageGain) > 0 ? (
              <p className="gain-palier">
                Soit
                <span>{` ${pourcentageGain} % `}</span>
                de gain sur le palier en cours
              </p>
            ) : null;
        }
        return (
          <div className="gain">
            {Gain}
            {PrixVenteConseille}
            {EcoTax}
          </div>
        );
      };

      const ArticleOffre = (): JSX.Element | null => {
        if (articles && detailOffre && articles?.length > 1) {
          let prevArticle: null | JSX.Element = null;
          let nextArticle: null | JSX.Element = null;

          const createProduct = (article: Article): CardProductInterface => {
            return {
              article_id: article.article_id,
              nom: article.nom || "",
              gencod: article.gencod || "",
              code_catalogue: article.code_catalogue || "",
              fournisseur: article.fournisseur || null,
              photos: article.photos || [],
              engagement_total_unites: article.engagement_total_unites || 0,
              engagement_total_adherents:
                article.engagement_total_adherents || 0,
              engagement_total_montant: article.engagement_total_montant || "0",
              reference: article?.reference || "",
            };
          };
          if (findIndexArticle && findIndexArticle > 0) {
            const article = articles[findIndexArticle - 1];
            const product: CardProductInterface = createProduct(article);
            prevArticle = (
              <div className="prevNext-content" id="prev">
                <p>&larr; Article Précédent</p>
                <CardProduct
                  product={product}
                  offre_id={detailOffre.offre_id}
                  small={true}
                />
              </div>
            );
          }
          if (
            findIndexArticle != undefined &&
            findIndexArticle < articles.length - 1
          ) {
            const article = articles[findIndexArticle + 1];
            const product: CardProductInterface = createProduct(article);
            nextArticle = (
              <div className="prevNext-content" id="next">
                <p>Article Suivant &rarr;</p>
                <CardProduct
                  product={product}
                  offre_id={detailOffre.offre_id}
                  small={true}
                />
              </div>
            );
          }
          return (
            <div className="prevNext">
              {prevArticle}
              {nextArticle}
            </div>
          );
        }
        return null;
      };
      const handleDownload = (id: number): void => {
        const url = `${getBFF()}/massification/v1/fichiers/${id}`;
        window.open(url, "_blank");
      };

      const FichiersToDl = (): JSX.Element[] | null => {
        if (fichiers) {
          const fichiersComponent = fichiers.map(fichier => {
            return (
              <div id="fichierArticle" key={fichier.fichier_id}>
                <p>{fichier.nom}</p>
                <Button
                  label="Télécharger"
                  variant={"secondary"}
                  onClick={() => handleDownload(fichier.fichier_id)}
                />
              </div>
            );
          });
          return fichiersComponent;
        }
        return null;
      };

      return (
        <>
          <Section id="detail_massification">
            <Button
              label="Retour"
              variant="secondary"
              icon={iconBack}
              className="returnButton"
              onClick={() =>
                navigate({
                  pathname: "/co-deals",
                  search: "",
                })
              }
            />
            <div className="detail-header">
              <Title title={nom} />
              <img
                className={cx(isCofalog() ? "detail-logo" : "hidden")}
                src={logoCofalog}
                alt="logo de la plateform Cofalog"
              />
            </div>
            <section>
              <div className="detail-produit">
                <div className="detail-produit--header">
                  <Photos photos={photos} />
                  <div className="detail-produit--info">
                    <h2>{produiDesignation}</h2>
                    <LineInfo label="Reference" value={reference} />
                    <LineInfo label="Code catalogue" value={code_catalogue} />
                    <LineInfo label="Gencod" value={gencod} />
                  </div>
                  <div className="detail-produit--offre">
                    {DateFin(date_fin)}
                    <a
                      href={offreIsActiveNow ? "#engagement" : "#"}
                      id={offreIsActiveNow ? "" : "prochainement"}>
                      {offreIsActiveNow ? "M'engager" : "Prochainement"}
                    </a>
                  </div>
                </div>
                <div className="detail-produit--detail">
                  <p id="produit_description">{produiDescription}</p>
                  {fichiers ? (
                    <div className="detail-produit--pj">
                      <BlocLabel label="Fichier à Télécharger" />
                      {FichiersToDl()}
                    </div>
                  ) : null}
                </div>

                <div>
                  <Palier
                    paliers={objectifPaliers}
                    current={engagement_value}
                    typePalier={type_palier}
                  />

                  {NbEngagement(
                    engagement_article,
                    detailOffre,
                    currentArticle,
                  )}
                </div>
                {ArticleOffre()}
              </div>
            </section>
            <section>
              <Title title={"Détails de l'offre"} />
              <div className="detail-offre">
                {description}
                <p id="pricing">Tous les prix de l'offre sont {pricing} </p>
                <div className="detail-offre--content">
                  <div className="detail-offre--responsable">
                    {negociateurs !== undefined
                      ? negociateurs.map((negociateur, index) => {
                          return (
                            <div key={negociateur.prenom_nom + index}>
                              <BlocLabel label={negociateur.fonction} />
                              <LineInfo
                                label="Nom"
                                value={negociateur.prenom_nom}
                                size="large"
                              />
                              <LineInfo
                                label="Service"
                                value={negociateur.service}
                                size="large"
                              />
                              <LineInfo
                                label="Téléphone"
                                value={negociateur.telephone}
                                size="large"
                              />
                              <LineInfo
                                label="mail"
                                value={negociateur.email}
                                size="large"
                              />
                            </div>
                          );
                        })
                      : null}
                  </div>
                  <div className="detail-offre--livraison">
                    <BlocLabel label={"Livraison"} />
                    <div className="livraison-information">
                      {livraisonFound
                        ? livraisonFound.map(livraison => {
                            return (
                              <LivraisonInfo
                                key={
                                  livraison.articles[0] +
                                  livraison.fournisseurs[0].fournisseur_id
                                }
                                fournisseurs={livraison.fournisseurs}
                              />
                            );
                          })
                        : null}
                    </div>
                  </div>
                  <div className="detail-offre--prix">
                    <BlocLabel label="Tarif de l'offre" variant="secondary" />
                    <Tableau
                      thead={FormatHeadTableau(
                        prix_quantitatif.sort(
                          (a, b) => a.quantite - b.quantite,
                        ),
                      )}
                      lignes={formatedDataPalierPrix}
                      firstCellUnit={type_palier}
                    />
                    <div>
                      {offreHasPalier ? (
                        <p>
                          * Objectif Cofaq à atteindre pour la validation de
                          l'offre.
                        </p>
                      ) : null}
                      {palierFound[0].articles.length > 1 ? (
                        <p>
                          ** Objectif commun, calculé à partir de l'ensemble des
                          engagements des produits de l'offre.
                        </p>
                      ) : null}
                    </div>

                    {GainSurPalier(
                      sortedPalier,
                      prix_quantitatif,
                      prix_vente_constate
                        ? parseFloat(prix_vente_constate)
                        : undefined,
                      tarif_fournisseur,
                      engagement_value,
                      prix_vente_constate_is_ttc,
                      eco_mob ? parseFloat(eco_mob) : undefined,
                      eco_par ? parseFloat(eco_par) : undefined,
                    )}
                  </div>
                  <div className="detail-offre--prix">
                    {hasTarif ? (
                      <>
                        <BlocLabel label="Tarif Permanent" />
                        <Tableau
                          thead={
                            <thead>
                              <tr>
                                <th>Unité</th>
                                <th>Prix permanent</th>
                              </tr>
                            </thead>
                          }
                          lignes={formatedTarifs}
                        />
                      </>
                    ) : null}
                    {commentaire ? (
                      <>
                        <BlocLabel label="Informations complémentaires" />
                        <p className="detail-offre--articleCommentaire">
                          {commentaire}
                        </p>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </section>
          </Section>
          {detailOffre?.engagements?.length > 0 ? (
            <Section id="currentEngagement">
              <Title title="Engagement en cour" />
              <div className="detail-currentEngagement">
                {detailOffre.engagements.map(engagement => {
                  return (
                    <>
                      <HistoriqueBloc
                        id={engagement.engagement_id}
                        type={"massification"}
                        key={engagement.engagement_id}>
                        <HistoriqueMassificationContent
                          articles={engagement.articles}
                          status={null}
                          adresse={engagement.adresse_livraison}
                        />
                      </HistoriqueBloc>
                    </>
                  );
                })}
              </div>
            </Section>
          ) : null}
          {detailOffre && offreIsActiveNow ? (
            <HookFormContextProvider<any>>
              <Engagement
                offre={detailOffre}
                updateOffre={value => {
                  if (value) setDetailOffre(value);
                }}
              />
            </HookFormContextProvider>
          ) : null}
        </>
      );
    }
  } else {
    return (
      <Section id="detail_massification">
        <Loader />
      </Section>
    );
  }
}

export default DetailMassification;
